import Layout from '@/layout'
const jxcRouter = {
  path: '/jxc/action',
  component: Layout,
  name: 'jxc',
  meta: {
    title: '进销存',
    icon: 'el-icon-box',
    roles: ['root', 'sg_company', 'pdi_company', 'ec_company', 'jxs_shop']
  },
  children: [
    {
      path: '/kc/list',
      name: 'jxcKcTable',
      component: () => import('@/views/jxc/kc/jxcKcTable'),
      meta: { title: '库存查询', icon: 'el-icon-help', roles: ['root', 'sg_company', 'pdi_company', 'ec_company', 'jxs_shop'], noCache: false }
    },
    {
      path: '/warehousing/create',
      name: 'warehousingCreate',
      component: () => import('@/views/jxc/action/warehousingCreate'),
      meta: { title: '添加进货单', icon: 'el-icon-plus', roles: ['root'], noCache: false }
    },
    {
      path: '/warehousing/update',
      name: 'warehousingUpdate',
      component: () => import('@/views/jxc/action/warehousingUpdate'),
      meta: { title: '更新进货单', icon: 'el-icon-plus', roles: ['root'], noCache: false },
      hidden: true
    },
    {
      path: '/transferGoods/create',
      name: 'transferGoodsCreate',
      component: () => import('@/views/jxc/action/transferGoodsCreate'),
      meta: { title: '添加调货单', icon: 'el-icon-s-promotion', roles: ['root', 'sg_company', 'pdi_company', 'ec_company'], noCache: false }
    },
    {
      path: '/transferGoods/update',
      name: 'transferGoodsUpdate',
      component: () => import('@/views/jxc/action/transferGoodsUpdate'),
      meta: { title: '更新调货单', icon: 'el-icon-refrigerator', roles: ['root', 'sg_company', 'pdi_company', 'ec_company', 'jxs_shop'], noCache: false },
      hidden: true
    },
    {
      path: '/returnGoods/create',
      name: 'returnGoodsCreate',
      component: () => import('@/views/jxc/action/returnGoodsCreate'),
      meta: { title: '添加退货单', icon: 'el-icon-refresh-left', roles: ['root', 'sg_company', 'pdi_company', 'ec_company', 'jxs_shop'], noCache: false }
    },
    {
      path: '/returnGoods/update',
      name: 'returnGoodsUpdate',
      component: () => import('@/views/jxc/action/returnGoodsUpdate'),
      meta: { title: '更新退货单', icon: 'el-icon-refresh-left', roles: ['root', 'sg_company', 'pdi_company', 'ec_company', 'jxs_shop'], noCache: false },
      hidden: true
    },
    {
      path: '/action/list',
      name: 'jxcActionTable',
      component: () => import('@/views/jxc/action/actionRecorderTable'),
      meta: { title: '出入库记录查询', icon: 'el-icon-search', roles: ['root', 'sg_company', 'pdi_company', 'ec_company', 'jxs_shop'], noCache: false }
    }
  ]
}
export default jxcRouter
